import React, { useState, useEffect } from "react";
import "./CookieBanner.css";
import { initAnalytics } from "../firebase";

const TEXT = {
  it: {
    text: "Questo sito utilizza cookie tecnici e analitici.",
    accept: "Accetta tutti",
    reject: "Rifiuta",
    settings: "Impostazioni"
  },
  en: {
    text: "This site uses technical and analytics cookies.",
    accept: "Accept all",
    reject: "Reject",
    settings: "Settings"
  },
  bs: {
    text: "Ova stranica koristi kolačiće.",
    accept: "Prihvati",
    reject: "Odbij",
    settings: "Postavke"
  },
  de: {
    text: "Diese Website verwendet Cookies.",
    accept: "Akzeptieren",
    reject: "Ablehnen",
    settings: "Einstellungen"
  }
};

export default function CookieBanner({ language = "it" }) {
  const [visible, setVisible] = useState(false);

  const t = TEXT[language] || TEXT.it;

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setVisible(true);
    } else if (consent === "accepted") {
      initAnalytics();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    initAnalytics();
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setVisible(false);
  };

  const openSettings = () => {
    window.location.href = "/cookie";
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>{t.text}</p>

        <div className="cookie-buttons">
          <button onClick={acceptCookies}>
            {t.accept}
          </button>

          <button onClick={rejectCookies}>
            {t.reject}
          </button>

          <button className="cookie-settings-btn" onClick={openSettings}>
            {t.settings}
          </button>
        </div>
      </div>
    </div>
  );
}
